var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-error-50 bg-border-container-danger p-4 rounded-xl"},[_c('div',{staticClass:"flex gap-x-4"},[_c('img',{staticClass:"custom-icon",attrs:{"src":_vm.cancelIcon}}),_c('div',[_c('p',{staticClass:"text-gray-dark"},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }